import request from './request';

export function fetchUnits() {
  return request('units', {
    method: 'GET'
  });
}
